import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconNoBoard = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconNoBoard",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m7.07 10.2-.3 4.51a.38.38 0 0 0 .64.29l2.07-2.07a.4.4 0 0 0 .11-.3l-.16-2.43c1.1-.58 1.82-1.93 1.82-3.45 0-2.07-1.35-3.75-3-3.75s-3 1.68-3 3.75c0 1.52.72 2.87 1.82 3.45m13.82-7.09a.4.4 0 0 0-.53 0L3.1 20.36a.4.4 0 0 0 0 .53.4.4 0 0 0 .53 0l2.92-2.91-.08 1.12a1.77 1.77 0 1 0 3.54 0l-.28-4.3 4.37-4.37.12.03-.6 8.67a1.75 1.75 0 1 0 3.5 0l-.6-8.67A1.9 1.9 0 0 0 18 8.63v-2.1l2.89-2.89a.4.4 0 0 0 0-.53m-7.49 5.9 1.49-1.49a.4.4 0 0 0 .1-.26V3.38a.38.38 0 1 0-.74 0v3.75a.38.38 0 0 1-.75 0V3.38a.38.38 0 1 0-.75 0v5.39a.38.38 0 0 0 .65.24m2.99-2.99a.4.4 0 0 0 .1-.26V3.38a.38.38 0 1 0-.74 0v2.38a.37.37 0 0 0 .64.26m1.5-1.5a.4.4 0 0 0 .1-.26v-.88a.38.38 0 1 0-.74 0v.88a.37.37 0 0 0 .64.26"
  })
}));
IconNoBoard.displayName = 'IconNoBoard';